import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-278cb3b9")

_pushScopeId("data-v-278cb3b9")
const _hoisted_1 = {
  key: 0,
  class: "change-layout"
}
const _hoisted_2 = { class: "description-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = {
  key: 1,
  class: "change-layout-mobile"
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "layout-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_LayoutItem = _resolveComponent("LayoutItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.t('layout.change')), 1),
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('layout.description')), 1)
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('menuList.changeLayout')), 1),
            _createVNode(_component_Button, {
              class: "done-btn",
              size: "s",
              mode: "flat",
              onClick: _ctx.closeDrawer
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('done')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])),
    _createVNode("div", _hoisted_8, [
      (!_ctx.isMobileScreen)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.activeItem.layoutItems, (item) => {
            return (_openBlock(), _createBlock(_component_LayoutItem, {
              key: item.name,
              name: item.name,
              description: item.description,
              layoutScreen: item.layoutScreen,
              type: item.type,
              active: _ctx.layoutType,
              onActive: ($event: any) => (_ctx.onSelectActive(item.type))
            }, null, 8, ["name", "description", "layoutScreen", "type", "active", "onActive"]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.isMobileScreen)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.layoutItemsMobile, (mobileItem) => {
            return (_openBlock(), _createBlock(_component_LayoutItem, {
              key: mobileItem.name,
              name: mobileItem.name,
              description: mobileItem.description,
              layoutScreen: mobileItem.layoutScreen,
              type: mobileItem.type,
              active: _ctx.layoutType,
              onActive: ($event: any) => (_ctx.onSelectActive(mobileItem.type))
            }, null, 8, ["name", "description", "layoutScreen", "type", "active", "onActive"]))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ], 64))
})